import { useState, useCallback } from 'react'

import { FixedBanner, Icon } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { useSettlementCreditLine } from '../../hooks/settlement-credit-line'

export interface ReferenceIdBannerProps {
  /**
   * Flag to check if the bank account has virtual account enabled.
   */
  virtualAccountEnabled?: boolean
  /**
   * Wire Instructions Reference ID.
   */
  referenceId?: string
}

export const ReferenceIdBanner: React.FC<ReferenceIdBannerProps> = ({
  virtualAccountEnabled,
  referenceId,
}) => {
  const { loading, translationKey } = useSettlementCreditLine()
  const { t } = useTranslation(`modals.${translationKey}`)

  const [refIdCopyIcon, setRefIdCopyIcon] = useState<
    'DuplicateOutline' | 'CheckOutline'
  >('DuplicateOutline')

  const handleCopyClick = useCallback(() => {
    if (referenceId === undefined) return

    void navigator.clipboard.writeText(referenceId)

    setRefIdCopyIcon('CheckOutline')

    setTimeout(() => {
      setRefIdCopyIcon('DuplicateOutline')
    }, 3000)
  }, [referenceId])

  if (loading) return null
  return (
    <FixedBanner
      className="border-none"
      visible={referenceId != null && !virtualAccountEnabled}
      hideIcon
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col gap-y-1">
          <p className="text-neutral-strong type-body-sm-bold">
            {t('depositInstructions.referenceIdLabel')}
          </p>
          <p className="text-xl text-interactive font-circular-bold">
            {referenceId}
          </p>
        </div>
        <Icon
          className="text-icon-primary"
          name={refIdCopyIcon}
          onClick={handleCopyClick}
          size={20}
        />
      </div>

      <p className="mt-1 text-neutral-strong type-body-sm">
        {t('depositInstructions.referenceIdFooter')}
      </p>
    </FixedBanner>
  )
}
